/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


window.loadingMore = false;

$(window).scroll(function() {


if (window.pageProducts != true) {
  return false;
}


   if($(window).scrollTop() + $(window).height() > $(document).height() - 100) {

if (window.loadingMore == true) {
  return false;
}
window.loadingMore = true;

var from = window.productsOffset;

$.ajax({
   url: window.productsEndpoint+'?from='+from,
   type: 'GET',
   error: function() {
      //
      window.loadingMore = false;
   },
   success: function(data) {
    console.log(data);

    var $d = $(data);

    $d.imagesLoaded(function() {
      $('.grid').append($d).isotope('appended', $d);
      window.loadingMore = false;
    });



   }
});

window.productsOffset += 10;

   }
});

$('.read-more').click(function(e){
    e.preventDefault();
    var $this = $(this);
    var $p = $this.prev('.desc');
    $p.toggleClass('opened');
    if($p.hasClass('opened')){
      $this.text('Show less');
    } else {
      $this.text('Show more');
    }
  });


  $('.fn-history-back').on('click', function() {
    e.preventDefault();
    window.history.back();
  });

  var sTable = $('#search-table').DataTable({
    paging: false,
    ordering: false
  });

  $('#search-table').hide(0);
  $('.results-title').hide(0);

  $('.search-field').keyup(function() {
    sTable.search($(this).val()).draw();

    if ($('.search-field').val() == '') {
      $('#search-table').hide(0);
      $('.results-title').hide(0);
    } else {
      $('#search-table').show(0);
      $('.results-title').show(0);
      $('.results-title span').text($('.search-field').val());
    }
  });

  $(window).load(function() {

  $('.grid').isotope({
    // options
    itemSelector: '.produit',
    layoutMode: 'fitRows',
    //gutterWidth: 10
  });

  });

  $('.fn-filter').on('click', function(e) {
    e.preventDefault();
    var category = $(this).attr('data-category');
    $('.produit-category-list a').removeClass('active');
    $(this).addClass('active');
    $('.grid').isotope({ filter: category });
  });

  $('.fn-top').on('click', function(e) {
    e.preventDefault();
    $(document).scrollTop(0);
  })

  $('.fn-filter.default').addClass('active');
  $('.grid').isotope({ filter: '*' });

  var uns = $('.unslider-1').unslider({
    speed: 500,               //  The speed to animate each slide (in milliseconds)
    delay: 3500,              //  The delay between slide animations (in milliseconds)
    complete: function() {},  //  A function that gets called after every slide animation
    keys: true,               //  Enable keyboard (left, right) arrow shortcuts
    dots: false,               //  Display dot navigation
    fluid: true              //  Support responsive design. May break non-responsive designs
  });
  window.us = uns.data('unslider');

  window.setTimeout(function() {
    $('.unslider-1').css('height', 'auto');
  }, 100);

  if ($('.unslider-1').length > 0) {
    window.us.stop();  
  }

  $('.slideshow-prev').on('click', function(e) {
    e.preventDefault();
    window.us.prev();
  });

  $('.slideshow-next').on('click', function(e) {
    e.preventDefault();
    window.us.next();
  });





  var uns2 = $('.unslider-2').unslider({
    speed: 500,               //  The speed to animate each slide (in milliseconds)
    delay: 5000000000,              //  The delay between slide animations (in milliseconds)
    complete: function() {},  //  A function that gets called after every slide animation
    keys: true,               //  Enable keyboard (left, right) arrow shortcuts
    dots: false,               //  Display dot navigation
    fluid: true              //  Support responsive design. May break non-responsive designs
  });
  window.us2 = uns2.data('unslider');

  if ($('.unslider-2').length > 0) {
    window.us2.stop();  
  }

  $('.slideshow-prev-2').on('click', function(e) {
    e.preventDefault();
    window.us2.prev();
  });

  $('.slideshow-next-2').on('click', function(e) {
    e.preventDefault();
    window.us2.next();
  });

$( "#accordion" ).accordion({
  heightStyle: "content",
  active:false,
  collapsible: true,
  create: function(event, ui) {
    $(this).css('visibility', 'visible');
  }
});

$('.fn-accordion').on('click', function(e) {
  e.preventDefault();
  var index = $(this).attr('data-accordion');
  console.log(index);
  if (index == "false") {
    index = false;
  }
  if (index !== false) {
    index = parseInt(index);
  }
  $('.fn-accordion img').removeClass('rotated');
  $(this).find('img').addClass('rotated');

  var currentIndex = $('#accordion').accordion('option', 'active');
  if (currentIndex === index) {
    index = false;
    $('.fn-accordion img').removeClass('rotated');
  }  
  $
  ( "#accordion" ).accordion({active: index});
  if (index !== false && index != "false") {
    $('.close-menu').css('display', 'inline-block');
  } else {
    $('.close-menu').css('display', 'none');
  }


});


  $('.empty-on-click').on('focus', function(e) {
    if ($(this).val() == $(this).attr('data-original')) {
      $(this).val('');
    }
  });

  $('.empty-on-click').on('blur', function(e) {
    if ($(this).val() == '') {
      $(this).val($(this).attr('data-original'));
    }
  });

  $('.fn-close-main-menu, .burger-menu').on('click', function(e) {
    $('body').removeClass('mobile-menu-open mobile-step-two');
    $('.mobile-step-fournisseurs').fadeOut(0);
    $('.mobile-step-produits').fadeOut(0);
    $('.mobile-step-one').fadeIn(0);

    $('.menu > *').not('.permanent').fadeOut(500);
    $('.menu').slideUp(750); // there was a 500 delay
    $('body').removeClass('no-scroll');
    $('.menu').removeClass('second');
  });

  $('.fn-open-main-menu').on('click', function(e) {
    $('body').addClass('mobile-menu-open');
    $('.menu .links').not('.permanent').delay(500).fadeIn(500);
    $('.menu').slideDown(750, function() {
      //
    });
    $('body').addClass('no-scroll');
  });

  $('.link-menu-plus').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('rotated');
    $(this).parent().parent().toggleClass('link-menu-plus-open');
  });
  $('.menu .links a.second').on('click', function(e) {
    e.preventDefault();
    $('.menu').addClass('second');
    $('.menu a').removeClass('active');
    $(this).addClass('active');

    switch ($(this).attr('data-item')) {
      case 'produits':
        $('.menu .links-produits').fadeIn(500);
        $('.menu .links-fournisseurs').fadeOut(500);
      break;
      case 'fournisseurs':
        $('.menu .links-fournisseurs').fadeIn(500);
        $('.menu .links-produits').fadeOut(500);
      break;
      default: 
        $('.menu .links-produits').fadeOut(500);
        $('.menu .links-fournisseurs').fadeOut(500);
      break;
    }
  });


  $('.menu-mobile .links a.second').on('click', function(e) {
    e.preventDefault();
    $('.mobile-step-one').fadeOut(500);

    switch ($(this).attr('data-item')) {
      case 'produits':
        $('body').addClass('mobile-step-two');
        $('.mobile-step-produits').delay(500).fadeIn(500);
      break;
      case 'fournisseurs':
        $('body').addClass('mobile-step-two');
        $('.mobile-step-fournisseurs').delay(500).fadeIn(500);
      break;
      default: 
      break;
    }
  });

  $(document).on('click', '.fn-mobile-plus ', function(e) {

  });

  $(document).on('click', '.fn-details', function(e) {
    e.preventDefault();
    $('.nouvelle-info').slideDown();
  });

  $(document).on('click', '.fn-close', function(e) {
    e.preventDefault();
    $('.nouvelle-info').slideUp();
  });

  $(document).on('click', '.fn-large-view', function(e) {
    e.preventDefault();
    $('.normal-view').hide(0);
    $('.large-view').show(0);
    window.setTimeout(function() {
      $('.unslider-2').css('height', 'auto');
    }, 100);
  });

  $(document).on('click', '.fn-normal-view', function(e) {
    e.preventDefault();
    $('.normal-view').show(0);
    $('.large-view').hide(0);
    window.setTimeout(function() {
      $('.unslider-1').css('height', 'auto');
    }, 100);
  });

  var doit;

  $(document).on('mouseenter', '.color-change', function() {
    if ($(window).width() < 1025) {
      return false;
    }
    var color = $(this).attr('data-color');
    var id = $(this).attr('data-id');
    clearTimeout(doit);
    doit = setTimeout(function() {
      changeColor(id, color);
      console.log(color);
    }, 250);
  });
  $(document).on('mouseleave', '.color-change', function() {
    clearTimeout(doit);
    doit = setTimeout(removeColor, 250);
  });

  function changeColor(id, color) {
    //$('body').attr('class', 'color-change');
    $('body').css('background', 'rgba(165, 165, 160, 1)').css('background', color);
    $('.pictures .picture').hide(0);
    $('.pictures .picture[data-id="'+id+'"]').show(0);
  }
  function removeColor() {
    //$('body').attr('class', 'color-change');
    $('body').css('background', 'rgba(165, 165, 160, 1)');
    $('.pictures .picture').hide(0);
  }

  $(document).on('click', '.close-home', function(e) {
    e.preventDefault();
    $('body').css('background-color', 'RGBA(165, 165, 160, 1)');
    $('.close-home').show(0);
    $('.pictures-fs').hide(0);
    $('.pictures-fs .picture').hide(0);
  });

  $('.popup').hide(0);
  $('.popup').delay(2000).slideDown(500);
  $('.fn-popup-close').on('click', function(e) {
    e.preventDefault();
    $('.popup').slideUp(500);
  });


  var defaults      = {
    selector:             '[data-adaptive-background]',
    exclude:              [ 'rgb(0,0,0)', 'rgba(255,255,255)' ],
    normalizeTextColor:   false,
    normalizedTextColors:  {
      light:      "#fff",
      dark:       "#000"
    },
    lumaClasses:  {
      light:      "ab-light",
      dark:       "ab-dark"
    },
    success: function($img, data) {
      console.log($img);
      console.log(data);
      var color = data.color.replace("rgb", "rgba").replace(")", ", .9)");
      $img.parent().find('.produit-overlay.do').css('background', color);
      $img.parent().find('.produit-mobile-name.do').css('background', color);

      if ($img.hasClass('ab-light')) {
        $img.parent().find('.produit-overlay.do').addClass('ab-light');
        $img.parent().find('.produit-mobile-name.do').addClass('ab-light');
      }
    }
  };
  $.adaptiveBackground.run(defaults)



      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
